export default [

     {
          path: '/third-party-vendor-repository-subsidiary',
          name: 'ThirdPartyVendorRepositorySubsidiary',
          component: () => import("@/views/Page/ThirdPartyVendorRepositorySubsidiary/ThirdPartyVendorRepositorySubsidiary.vue"),
           meta: {
               title: '#Default# | ThirdPartyVendorRepositorySubsidiary',
          },
     }
];